import DataComplianceMissingType = App.Enums.DataComplianceMissingType;
import DataComplianceUserItineraryData = App.Data.DataComplianceUserItineraryData;
import DataComplianceUserItineraryReferenceData = App.Data.DataComplianceUserItineraryReferenceData;

export type TripSelectionScope = 'all' | DataComplianceMissingType;

export interface SelectableVisibleItinerary {
	reference: DataComplianceUserItineraryReferenceData;
	complianceGapType: DataComplianceMissingType;
}

export const getItinerarySelectionKey = (reference: DataComplianceUserItineraryReferenceData) =>
	`${reference.itineraryId}:${reference.travelerId}`;

export const getItineraryRowKey = (itinerary: DataComplianceUserItineraryData) =>
	[itinerary.id, itinerary.travelerId ?? 'traveler', itinerary.complianceGapType].join('-');

export const getDestinationDisplayName = (itinerary: DataComplianceUserItineraryData) =>
	itinerary.destinationPlace?.name || itinerary.city;
